import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues10, LessAlert, LocalService, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { AddMessageCreditsComponent } from '../add-message-credits/add-message-credits.component';
import { SmsSettingsComponent } from '../sms-settings/sms-settings.component';

@Component({
  selector: 'app-less-credits',
  templateUrl: './less-credits.component.html',
  styleUrls: ['./less-credits.component.scss']
})
export class LessCreditsComponent implements OnInit {
  lessAlert: LessAlert; lstSectionConfigKeys: string[] = ["sms_settings"]; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public profileManagementService: ProfileManagementService, private activeModal: NgbActiveModal, private modalService: NgbModal, private router: Router) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  onLoad() {
    this.profileManagementService.getLessAlert().subscribe(result => {
      if (result && result.messageCredits.length > 0) {
        this.lessAlert = result;
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onAction(index: number, strBusinessId: string, strRelationShipType: string) {
    switch (index) {
      case 1: {
        let notificationType = parseInt(this.lessAlert.messageCredits.find(x => x.key.key == strBusinessId && x.key.v3 == strRelationShipType).values[0].v2);
        let relationShipType = parseInt(strRelationShipType);
        const modalRef = this.modalService.open(AddMessageCreditsComponent);
        modalRef.componentInstance.businessId = strBusinessId;
        modalRef.componentInstance.relationShipType = relationShipType;
        modalRef.componentInstance.notificationType = notificationType;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.onLoad();
          }
        });
      } break;
      case 2: {
        let notificationType = parseInt(this.lessAlert.messageCredits.find(x => x.key.key == strBusinessId && x.key.v3 == strRelationShipType).values[0].v2);
        let relationShipType = parseInt(strRelationShipType);
        const modalRef = this.modalService.open(SmsSettingsComponent, { size: 'lg' });
        modalRef.componentInstance.businessId = strBusinessId;
        modalRef.componentInstance.relationShipType = relationShipType;
        modalRef.componentInstance.notificationType = notificationType;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.onLoad();
          }
        });
      } break;
      case 3: {
        this.router.navigate(['/payments/' + this.localService.basicParams.countryCode, this.localService.basicParams.userId, strRelationShipType, strBusinessId]);
        this.activeModal.close({ event: TriggeredEvent.Close });
      } break;
    }
  }
}
